<template>
  <div class="mask" v-show="isShow">
    <div class="locationChooseWrapper">
      <div class="close" @click="toggleShow"></div>
      <dl class="chooseLocation">
        <dt class="l line">选择地址:</dt>
        <dd class="l location">
          <div class="province l">
            <Select class="border indexLocation" v-model="selectProvince" :list="provinceList" v-on:onSelectChange="city" ></Select>
          </div>
          <div class="city l">
            <Select class="border indexLocation" v-model="selectCity" :list="cityList" v-on:onSelectChange="areas"></Select>
          </div>
          <div class="area l">
            <Select class="border indexLocation" v-model="selectArea" :list="areaList" v-on:onSelectChange="areasCode" ></Select>
          </div>
        </dd>
      </dl>
      <dl class="currentLocation">
        <dt class="l">当前位置:</dt>
        <dd class="historyLocation l" @click="changeArea(localtionArea)">{{localtionAreaStr}}</dd>
      </dl>
      <dl class="lately">
        <dt class="l">最近访问:</dt>
        <dd class="hidtoryArea">
          <div class="historyLocation l"  v-for="(item, index) in choosedCitys" :key="index"
               @click="changeArea(item)">{{item.detailDesc}}</div>
        </dd>
      </dl>
      <dl class="tips">
        <dt class="l">温馨提示:</dt>
        <dd class="l">选择特定的区域即可查看与本区域相关的资讯！</dd>
      </dl>
    </div>
  </div>
</template>
<script>
  import Select from './select.vue'
  import {api} from '../common/config.js'
  import {store} from '../store/store.js'
  import {ajaxUtil} from '../common/AjaxUtil.js';
  import {StorageUtil} from '../common/Auth.js';
  import {CommonUtil} from '../common/CommonUtil.js';
  export default {
    name: 'indexLocation',
    components: {
      Select
    },
    data() {
      return {
        isShow: false,
        area: null,//高级搜索区域code
        selectProvince: {desc: '省'},
        selectCity: {desc: '市'},
        selectArea: {desc: '区'},
        provinceList: [],
        /**
         * hasChild是否市区下还有区域    1：有；0：无
         * provinceCode 省代码
         */
        cityList: [],
        areaList: [],
        choosedCitys:"",
        localtionAreaStr:"",
        localtionArea:"",
      }
    },
    created() {
      this.province();
    },
    mounted() {
     this.choosedCitys=store.choosedCitys;
      this.locationGaode();
    },
    methods: {
      toggleShow() {
        this.isShow = !this.isShow;
      },
      //选择历史和当前定位
      changeArea:function (item) {
        var chooseAreaData={code:item.code,desc:item.desc};
        store.chooseArea=chooseAreaData;
        StorageUtil.storeObject("chooseArea",chooseAreaData);

        if(Object.prototype.toString.call(store.choosedCitys) !== "[object Array]"){
          store.choosedCitys=new Array();
        }
        var choosedCitysData=store.choosedCitys;
        var detailDescStr="";
        if(item.code==store.localtionArea.code){
           detailDescStr=this.localtionAreaStr;
        }else{
           detailDescStr=item.detailDesc;
        }
        choosedCitysData.unshift({code:item.code,desc:item.desc,detailDesc:detailDescStr});
        store.choosedCitys =CommonUtil.arrayUniqueObj(choosedCitysData,"code").slice(0,20);
        StorageUtil.storeObject("choosedCitys",store.choosedCitys);

        this.toggleShow();
        CommonUtil.changeURLPar({"code":item.code});
      },
      //获取区的Code
      areasCode: function () {
        if(this.selectArea.desc=="区"){
          this.selectArea=this.selectCity;
        }
        var chooseAreaData={code:this.selectArea.code,desc: this.selectArea.desc};
        var areaDesc="";
        if(this.selectCity.desc!=this.selectArea.desc){
          areaDesc="-"+this.selectArea.desc;
        }
        var detailDescStr=this.selectProvince.desc+"-"+this.selectCity.desc+areaDesc;
        store.chooseArea=chooseAreaData;
        StorageUtil.storeObject("chooseArea",chooseAreaData);
        if(Object.prototype.toString.call(store.choosedCitys) !== "[object Array]"){
          store.choosedCitys=new Array();
        }
        var choosedCitysData=store.choosedCitys;
        choosedCitysData.unshift({code:this.selectArea.code,desc: this.selectArea.desc,detailDesc:detailDescStr});
        store.choosedCitys =CommonUtil.arrayUniqueObj(choosedCitysData,"code").slice(0,20);
        StorageUtil.storeObject("choosedCitys",store.choosedCitys);
        this.toggleShow();
        CommonUtil.changeURLPar({"code":this.selectArea.code});
      },
      //高德定位
      locationGaode: function () {
        var _this = this;
        var map = new AMap.Map('iCenter');
        map.plugin('AMap.Geolocation', function() {
          var geolocation = new AMap.Geolocation({
            timeout: 10000, //超过10秒后停止定位，默认：无穷大
          });
          geolocation.getCurrentPosition();
          AMap.event.addListener(geolocation, 'complete', _this.locationComplete);//返回定位信息
          AMap.event.addListener(geolocation, 'error',_this.locationError);      //返回定位出错信息
        });
      },
      //定位成功
      locationComplete: function (data) {
        var detailDescStr=data.addressComponent.province+"-"+data.addressComponent.city+"-"+data.addressComponent.district;
        var localtionAreaData={
          code:data.addressComponent.adcode,
          desc: data.addressComponent.district,
          detailDesc:detailDescStr,
          latLng:data.position.getLng()+","+data.position.getLat()
        };
        this.localtionAreaStr=detailDescStr;
        this.localtionArea=localtionAreaData;
        store.localtionArea=localtionAreaData;
        StorageUtil.storeObject("localtionArea",localtionAreaData);
        if(store.chooseArea==null){
          var chooseAreaData={code:data.addressComponent.adcode,desc: data.addressComponent.district};
          StorageUtil.storeObject("chooseArea",chooseAreaData);
          store.chooseArea=chooseAreaData;
        }
        /*if(!this.$route.query.latLng) {
          history.pushState(null,'',`?latLng=${store.localtionArea.latLng}`)
        }*/
      },
      //定位失败
      locationError: function (data) {
        var localtionAreaData={//定位失败的话，默认为锦江区
          code:"510104",
          desc: "锦江区",
          detailDesc:"四川省-成都市-锦江区",
          latLng:"104.0658,30.65734"};
        this.localtionAreaStr="四川省-成都市-锦江区";
        this.localtionArea=localtionAreaData;
        store.localtionArea=localtionAreaData;
        StorageUtil.storeObject("localtionArea",localtionAreaData);

        if(store.chooseArea==null){
          var chooseAreaData={code:"510104",desc: "锦江区"};
          StorageUtil.storeObject("chooseArea",chooseAreaData);
          store.chooseArea=chooseAreaData;
        }
        console.log("定位失败:"+JSON.stringify(data));
      },
      //省
      province: function () {
        var _this = this;
        var url = api.area.province;
        ajaxUtil.ajaxJson(url, null, "get",function (data) {
          if (data != null) {
            for (var i = 0; i < data.length; i++) {
              var obj = {desc: data[i].name, code: data[i].code, id: data[i].id};
              _this.provinceList.push(obj);
            }
          }
        },null,this);
      },
      //市
      city: function () {
        var _this = this;
        //初始化
        _this.cityList = [];
        _this.selectCity = {desc: '市'};
        _this.selectArea={desc: '区'};
        //省code码
        var provinceCode = _this.selectProvince.code;
        var url = api.area.city.replace('{provinceCode}', provinceCode);
        ajaxUtil.ajaxJson(url, null, "get",function (data) {
          if (data != null) {
            for (var i = 0; i < data.length; i++) {
              var obj = {
                desc: data[i].name,
                code: data[i].code,
                id: data[i].id,
                hasChild: data[i].hasChild,
                provinceCode: data[i].provinceCode
              };
              _this.cityList.push(obj);
            }
          }
        },null,this);
      },
      //区
      areas: function () {
        var _this = this;
        //市code
        var cityCode = _this.selectCity.code;
        //初始化
        _this.areaList = [];
        _this.selectArea = {desc: '区'};
        var url = api.area.area.replace('{cityCode}', cityCode);
        ajaxUtil.ajaxJson(url, null, "get",function (data) {
          if (data != null) {
            for (var i = 0; i < data.length; i++) {
                var obj = {
                  desc: data[i].name,
                  code: data[i].code,
                  id: data[i].id,
                  cityCode: data[i].cityCode
                };
                _this.areaList.push(obj);
            }
          }else{
            _this.areasCode();
          }
        },null,this);
      },
    }
  }
</script>
<style scoped lang="sass">
  .locationChooseWrapper
    @include ele-middle-center($container-width,634px)
    background: #fff
    z-index: 999
    border-radius: 3px

  .chooseLocation
    margin-top: 50px
    height: 44px
    /*line-height: 44px*/
    .line
      line-height: 44px
  .location > div
    margin-left: -1px
    width: 122px
    height: 44px
    border: 1px solid #d3d3d3
  dt
    margin-right: 8px
    width: 97px
    height: 100%
    text-align: right

  .currentLocation, .lately ,.tips
    margin-top: 20px
    height: 55px
    line-height: 55px

  .lately
    height: auto
    min-height: 55px

  .tips
    color: #ff0000!important

  .hidtoryArea
    margin: 0 auto
    overflow: hidden

  .historyLocation
    margin-right: 35px
    color: #0000cc
    cursor: pointer

  .tips
    color: #999
  .close
    background: url("../assets/images/Close.png") no-repeat
    background-size: contain
</style>
